// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"57fab92d","239":"0ef1baa4","453":"30fd558e","455":"8b7a766a","915":"4cc616e4"}[chunkId] + ".chunk.js";
};